exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tc-accordion .acdn-title a[data-v-3dc26e0c]:after,\n.tc-accordion .acdn-title a.collapsed[data-v-3dc26e0c]:after{\n    content: ''\n}\n", ""]);

// exports
